module.exports = __webpack_public_path__ + "img/cont-08-pari.8f49779d.svg";